module.exports = __webpack_public_path__ + "static/media/statistics.8d612bf1.gif";